import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merges class names; Tailwind utilities later in the list win on conflicts.
 */
export const cn = (...inputs: readonly ClassValue[]): string =>
  twMerge(clsx(inputs))
